<template>
  <div class="pages">
    <!-- 车辆属性信息 -->
    <car-attribute-list ref="carAttributeList" :carAttributeFeeConfig="carAttributeFeeConfig" style="margin-bottom: 40px;" :car-type-id.sync="carTypeId" />
    <!-- 里程费 -->
    <mileage-fee ref="mileageFee" :carAttributeFeeConfig="carAttributeFeeConfig" style="margin-bottom: 24px;" v-if="carAttributeFeeConfig.mileages && isSystemQuotation==='system'" />
    <!-- 装卸搬运费计算规则 -->
    <loading-unloading-fee ref="loadingUnloadingFee" :carAttributeFeeConfig="carAttributeFeeConfig" style="margin-bottom: 24px;" v-if="carAttributeFeeConfig.bulkCargoFeeInfo" />
    <!-- 二次费用 -->
    <secondary-fee ref="secondaryFee" :carAttributeFeeConfig="carAttributeFeeConfig" style="margin-bottom: 24px;" />
    <!-- 发票费用 -->
    <invoice-fee ref="invoiceFee" :carAttributeFeeConfig="carAttributeFeeConfig" style="margin-bottom: 24px;" v-if="carAttributeFeeConfig.invoiceInfo" />
    <!-- 其他服务费 -->
    <other-fee ref="otherFee" :carAttributeFeeConfig="carAttributeFeeConfig" />
    <!-- 预览图片 -->
    <image-preview ref="imagePreview" />
    <car-attribute-details-popup ref="carAttributeDetailsPopup" />
  </div>
</template>

<script>
import { Toast } from "vant";
import { getCarAttributeFeeConfig } from "@/api/beecargo/loadingUnloadingChargingRules/index.js";
import carAttributeList from "@/view/beecargo/loadingUnloadingChargingRules/components/car-attribute-list.vue";
import mileageFee from "@/view/beecargo/loadingUnloadingChargingRules/components/mileage-fee.vue";
import loadingUnloadingFee from "@/view/beecargo/loadingUnloadingChargingRules/components/loading-unloading-fee.vue";
import secondaryFee from "@/view/beecargo/loadingUnloadingChargingRules/components/secondary-fee.vue";
import invoiceFee from "@/view/beecargo/loadingUnloadingChargingRules/components/invoice-fee.vue";
import otherFee from "@/view/beecargo/loadingUnloadingChargingRules/components/other-fee.vue";
import imagePreview from "@/view/beecargo/loadingUnloadingChargingRules/components/image-preview.vue";
import carAttributeDetailsPopup from "@/view/beecargo/loadingUnloadingChargingRules/components/car-attribute-details-popup.vue";
export default {
  components:{ 
    carAttributeList ,
    mileageFee ,
    loadingUnloadingFee ,
    secondaryFee ,
    invoiceFee ,
    otherFee ,
    imagePreview ,
    carAttributeDetailsPopup ,
    [Toast.name]:Toast
  },
  data(){
    return {
      carTypeId:null,
      carAttributeFeeConfig:{},
      isSystemQuotation:'system'
    }
  },
  provide(){
    return {
      imagePreview: options => this.$refs["imagePreview"].show(options),
      carAttributeDetailsPopup : options => this.$refs["carAttributeDetailsPopup"].show(options)
    }
  },
  watch:{
    carTypeId(id){
      if(!id) return false;
      this.getCarAttributeFeeConfig(id);
    }
  },
  methods:{
    getCarAttributeFeeConfig(carTypeId){
      this.$toast({
        type:"loading",
        forbidClick:true,
        duration:0,
        message:"加载中"
      });
      let orderSource = this.$route.query.orderSource;
      if(orderSource === "app_vip") orderSource = "vipapp";
      this.isSystemQuotation = this.$route.query.isSystemQuotation?this.$route.query.isSystemQuotation:'system';
      return getCarAttributeFeeConfig({
        params:{ carTypeId },
        orderSource,  //orderSource:   app:小蜜蜂个人版   vipapp:小蜜蜂企业版
      }).then(({ data }) => {
        if(!data) return false;
        this.carAttributeFeeConfig = data;
      }).finally(()=>Toast.clear())
    }
  }
}
</script>

<style scoped lang="scss">
  .pages {
    background-color: #FFF;
    padding-bottom: 46px;
  }
  ::v-deep .component {
    padding: 0 12px;
    .component-title {
      font-size: 16px;
      color: #EC892E;
      line-height: 32px;
      padding-left: 7px;
      position: relative;
      &:before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 8px;
        top: 8px;
        z-index: 1;
        width: 3px;
        border-radius: 1px;
        background-color: #EC892E;
      }
    }
    .flex-sb {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
</style>